import React from 'react';
import PropTypes from 'prop-types';
import LoadingDots from '../../shared/LoadingDots';

const LabTestList = ({ labTests, loading }) => (
  <>
    {loading &&  <LoadingDots height={10} width={30} color="#38AD3E" />
}

    {!loading && labTests.length === 0 && (
      <p>No lab tests found.</p>
    )}

    {!loading && labTests.length > 0 && (
      <div className='prescription-grid'>
    
        {labTests.map((test) => (
 
          <div key={test.id}  className="item w-full" >
            <p>
              <strong>Test Type:</strong> {test.lab_test_type_name}
            </p>
            <p>
              <strong>Status:</strong> {test.status}
            </p>
            <p>
              <strong>Result:</strong> {test.result || 'Pending'}
            </p>
            <p className="text-sm text-gray-500">
              Requested:{' '}
              {new Date(test.created_at).toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                weekday: 'short',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </p>
          </div>
        ))}
      </div>
    )}
  </>
);

LabTestList.propTypes = {
  labTests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
      result: PropTypes.string,
      created_at: PropTypes.string.isRequired,   
      lab_test_type: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
       }),
       }),
    ).isRequired,
    
  loading: PropTypes.bool.isRequired,
};

export default LabTestList;
